<div class="mx-4 my-4 px-4 py-4 flex flex-col text-white bg-black/15 rounded-sm">
  <h1 class="text-lg font-bold text-yellow-400">Current Banner Notifications</h1>
  <h2 class="text-md">The following banner notifications are currently LIVE and displayed accross scanners</h2>
  <div class="flex items-center gap-2 my-2">
    <!-- <label for="fileUpload" class="px-3 py-1 bg-app-teal-100 text-black rounded-sm cursor-pointer hover:bg-app-teal-200">
      Select File
    </label> -->
    <!-- <span id="fileName" class="text-sm text-gray-300">No file selected</span> -->
  </div>
  <div *ngFor="let n of notifications" class="mt-2 px-4 py-4 bg-[#00358B]/15 rounded-sm flex items-center">
    <i class="fa-solid fa-circle-info text-[#7bdfff] text-2xl px-2 mr-1"></i>
    <div class="flex flex-col">
      <span>{{n.CreatedAt}} — {{n.Message}}</span>
      <div>
        <span class="text-sm text-app-teal-100 mr-1 italic">Who sees:</span>
        <span class="text-white">{{n.Client}}</span>
      </div>
    </div>
    <button class="ml-auto px-3 py-1 bg-red-700 text-white rounded-sm transition hover:bg-red-700/80 cursor-pointer font-semibold"
    (click)="notifyService.deleteNotification(n.Id)">
      Delete
    </button>
  </div>
</div>


<div class="mx-4 my-4 px-4 py-4 flex flex-col text-white bg-black/15 rounded-sm">
  <h1 class="text-lg font-bold text-app-teal-100">Add New Banner Notification</h1>
  <h2 class="text-md">Enter the details to add a new banner notification to be displayed on selected scanners</h2>
  <div class="flex items-start justify-center gap-4 my-4">

    <mat-form-field class="w-62">
      <mat-label class="text-app-teal-100 font-semibold">Client Id</mat-label>
      <select matNativeControl required [(ngModel)]="new_notification.Client" style="background-color: #131421 !important;">
        <option *ngFor="let id of clients" [value]="id">{{id}}</option>
      </select>
      <mat-hint class="text-xs">Who will see this notification</mat-hint>
    </mat-form-field>

    <mat-form-field class="flex-1">
      <mat-label class="text-app-teal-100 font-semibold">Notification Message</mat-label>
      <textarea class="text-white" matInput required [(ngModel)]="new_notification.Message" rows="1"></textarea>
    </mat-form-field>
  </div>
  <h2 class="text-gray-400">Notification Preview:</h2>
  <div *ngIf="new_notification.Message" class="mt-2 px-4 py-4 bg-[#00358B] rounded-sm flex items-center">
    <i class="fa-solid fa-circle-info text-[#7bdfff] text-2xl px-2 mr-1"></i>
    <div class="flex flex-col">
      <span>{{new_notification.CreatedAt}} — {{new_notification.Message}}</span>
    </div>
  </div>
  <button [disabled]="!add_notification_enabled()" (click)="add_notification()"
  class="mt-4 ml-auto px-3 py-1 bg-blue-500 text-white rounded-sm transition font-semibold"
  [class.bg-gray-600]="!add_notification_enabled()"
  [class.cursor-pointer]="add_notification_enabled()"
  >
    Add Notification
  </button>
</div>